import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'

interface CardTypeTooltipProps {
  className?: string
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
  onHover?: () => void
}

const CardTypeTooltip: React.FC<CardTypeTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip
      className={props.className}
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
      onHover={props.onHover}
    >
      <p>
        {translate(
          'Look for "corporate" or "business" on the front of your Amex card',
        )}
      </p>
    </Tooltip>
  )
}

export default CardTypeTooltip
